import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_3 = { class: "form__icon form__icon--down form__input-wrapper" }
const _hoisted_4 = ["id", "value", "name", "disabled", "aria-describedby"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_8 = {
  key: 2,
  class: "form__character-limit"
}
const _hoisted_9 = ["id", "value", "type", "name", "maxlength", "disabled", "aria-describedby"]
const _hoisted_10 = {
  key: 2,
  class: "checkbox-wrapper"
}
const _hoisted_11 = ["id", "value", "name", "disabled", "aria-describedby"]
const _hoisted_12 = { class: "checkbox__label" }
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_17 = { class: "form__icon form__icon--down" }
const _hoisted_18 = ["id", "value", "name", "disabled", "aria-describedby"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon--plus" }, null, -1 /* HOISTED */)
const _hoisted_22 = ["for"]
const _hoisted_23 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_24 = ["for"]
const _hoisted_25 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_28 = ["for"]
const _hoisted_29 = {
  key: 1,
  class: "form__sub-label"
}
const _hoisted_30 = ["id", "value", "type", "name", "placeholder", "disabled", "aria-describedby"]
const _hoisted_31 = ["id"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form__set", $props.groupClass])
  }, [
    ($props.type === 'select')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($props.label && !_ctx.hideLabel)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: $props.inputId,
                class: "form__label"
              }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_1))
            : _createCommentVNode("v-if", true),
          ($props.subLabel)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($props.subLabel), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("select", {
              id: $props.inputId,
              value: $props.value,
              name: $props.inputId,
              class: _normalizeClass(["form__select", ( $props.inputClass ) + ( $props.errors ? ' form__select--error' : '' )]),
              disabled: $props.disabled,
              "aria-describedby": ( $props.subLabel ? $props.inputId + '-description ' : '' ) + ( $props.errors ? $props.inputId + '-error' : '' ),
              onInput: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:value', $event.target.value)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index + '-' + $props.inputId,
                  value: option.value
                }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_5))
              }), 128 /* KEYED_FRAGMENT */))
            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_4)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : ($props.type === 'textarea')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($props.label && !_ctx.hideLabel)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  for: $props.inputId,
                  class: "form__label"
                }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true),
            ($props.subLabel)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($props.subLabel), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($props.charLimit)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.remaining_character_count) + " characters left ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("textarea", {
              id: $props.inputId,
              value: $props.value,
              type: $props.type,
              name: $props.name,
              class: _normalizeClass(["form__input", ( $props.inputClass ) + ( $props.errors ? ' form__input--error' : '' )]),
              rows: "6",
              maxlength: $props.charLimit,
              disabled: $props.disabled,
              "aria-describedby": ( $props.subLabel ? $props.inputId + '-description ' : '' ) + ( $props.inputId + '-max-length-description ' ) + ( $props.errors ? $props.inputId + '-error' : '' ),
              onInput: _cache[1] || (_cache[1] = $event => (_ctx.$emit( 'update:value', $event.target.value )))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_9)
          ], 64 /* STABLE_FRAGMENT */))
        : ($props.type === 'checkbox')
          ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: $props.inputId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.checked_items) = $event)),
                class: _normalizeClass(["checkbox", ( $props.inputClass ) + ( $props.errors ? ' checkbox--error' : '' )]),
                value: $props.value,
                type: "checkbox",
                name: $props.name,
                disabled: $props.disabled,
                "aria-describedby": ( $props.subLabel ? $props.inputId + '-description ' : '' ) + ( $props.errors ? $props.inputId + '-error' : '' )
              }, null, 10 /* CLASS, PROPS */, _hoisted_11), [
                [_vModelCheckbox, $setup.checked_items]
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString($props.label), 1 /* TEXT */)
            ]))
          : ($props.type === 'dateinputs')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                ($props.label && !_ctx.hideLabel)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      for: $props.inputId,
                      class: "form__label"
                    }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_13))
                  : _createCommentVNode("v-if", true),
                ($props.subLabel)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($props.subLabel), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createVNode($setup["InputDateComponent"], {
                  "input-id": $props.inputId,
                  value: $props.value,
                  error: null !== $props.errors && $props.errors.length > 0,
                  onUpdated: _cache[3] || (_cache[3] = new_value => _ctx.$emit( 'update:value', new_value ))
                }, null, 8 /* PROPS */, ["input-id", "value", "error"])
              ], 64 /* STABLE_FRAGMENT */))
            : ($props.type === 'multiselect')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  ($props.label && !_ctx.hideLabel)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        for: $props.inputId,
                        class: "form__label"
                      }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true),
                  ($props.subLabel)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($props.subLabel), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.multiselect_inputs, (multiselect_value, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "form__input-with-remove"
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(), _createElementBlock("select", {
                          id: $props.inputId + '_' + key,
                          key: 'multiselect-input-' + key,
                          ref_for: true,
                          ref: "multiselect_input_refs",
                          value: multiselect_value,
                          name: $props.name,
                          class: _normalizeClass(["form__select", ( $props.inputClass ) + ( $props.errors ? ' form__select--error' : '' )]),
                          disabled: $props.disabled,
                          "aria-describedby": ( $props.subLabel ? $props.inputId + '-description ' : '' ) + ( $props.errors ? $props.inputId + '-error' : '' ),
                          onInput: _cache[4] || (_cache[4] = $event => (_ctx.$emit('update:value', $event.target.value)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, option_key) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option_key,
                              value: option_key
                            }, _toDisplayString(option), 9 /* TEXT, PROPS */, _hoisted_19))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18))
                      ]),
                      (_openBlock(), _createElementBlock("button", {
                        key: 'multiselect-remove-' + key,
                        type: "button",
                        class: "icon icon--close",
                        "aria-label": "Remove this input",
                        onClick: $event => ($setup.removeMultiselectInput( key ))
                      }, null, 8 /* PROPS */, _hoisted_20))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "button button--small",
                    onClick: $setup.addMultiselectInput
                  }, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString($props.addText), 1 /* TEXT */)
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : ($props.type === 'checkboxes-dropdown')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    ($props.label && !_ctx.hideLabel)
                      ? (_openBlock(), _createElementBlock("label", {
                          key: 0,
                          for: $props.inputId,
                          class: "form__label"
                        }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_22))
                      : _createCommentVNode("v-if", true),
                    ($props.subLabel)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString($props.subLabel), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode($setup["CheckboxesDropdownComponent"], {
                      id: $props.inputId,
                      label: $props.label,
                      placeholder: $props.placeholder,
                      options: $props.options,
                      "unfiltered-options": _ctx.unfilteredOptions,
                      query: $props.filterSearch,
                      selection: $props.activeValues,
                      stretch: true,
                      "search-disabled": false,
                      loading: false,
                      "selection-label": $props.selectionLabel,
                      onSelect: _cache[5] || (_cache[5] = new_value => _ctx.$emit( 'update:value', new_value )),
                      "onUpdate:query": $setup.handleSearchInputChange
                    }, null, 8 /* PROPS */, ["id", "label", "placeholder", "options", "unfiltered-options", "query", "selection", "selection-label"])
                  ], 64 /* STABLE_FRAGMENT */))
                : ($props.type === 'button-dropdown')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      ($props.label && !_ctx.hideLabel)
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 0,
                            for: $props.inputId,
                            class: "form__label"
                          }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_24))
                        : _createCommentVNode("v-if", true),
                      ($props.subLabel)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString($props.subLabel), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createVNode($setup["ButtonDropdownComponent"], {
                        id: $props.inputId,
                        label: $props.label,
                        placeholder: $props.placeholder,
                        options: $props.options,
                        query: $props.filterSearch,
                        stretch: true,
                        "search-disabled": false,
                        loading: false,
                        onSelect: _cache[6] || (_cache[6] = new_value => _ctx.$emit( 'update:value', new_value )),
                        "onUpdate:query": $setup.handleSearchInputChange
                      }, null, 8 /* PROPS */, ["id", "label", "placeholder", "options", "query"])
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($props.type === 'multilevel-dropdown')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        ($props.label && !_ctx.hideLabel)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              for: $props.inputId,
                              class: "form__label"
                            }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_26))
                          : _createCommentVNode("v-if", true),
                        ($props.subLabel)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString($props.subLabel), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createVNode($setup["MultiLevelDropdownComponent"], {
                          id: $props.inputId,
                          label: $props.label,
                          placeholder: $props.placeholder,
                          options: $props.options,
                          stretch: true,
                          "search-disabled": false,
                          loading: false,
                          onSelect: _cache[7] || (_cache[7] = new_value => _ctx.$emit( 'update:value', new_value )),
                          "onRefresh:projectLocations": _cache[8] || (_cache[8] = ( value, handle ) => $setup.emitUpdateLocations( value, handle ))
                        }, null, 8 /* PROPS */, ["id", "label", "placeholder", "options"])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        ($props.label && !_ctx.hideLabel)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              for: $props.inputId,
                              class: "form__label"
                            }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_28))
                          : _createCommentVNode("v-if", true),
                        ($props.subLabel)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($props.subLabel), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("input", {
                          id: $props.inputId,
                          value: $props.value,
                          type: $props.type,
                          name: $props.name,
                          placeholder: $props.placeholder,
                          disabled: $props.disabled,
                          "aria-describedby": ( $props.subLabel ? $props.inputId + '-description ' : '' ) + ( $props.errors ? $props.inputId + '-error' : '' ),
                          class: _normalizeClass(["form__input", ( $props.inputClass ) + ( $props.errors ? ' form__input--error' : '' )]),
                          onInput: _cache[9] || (_cache[9] = $event => (_ctx.$emit( 'update:value', $event.target.value ))),
                          onBlur: _cache[10] || (_cache[10] = $event => (_ctx.$emit( 'blur' )))
                        }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_30)
                      ], 64 /* STABLE_FRAGMENT */)),
    ($props.errors)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 9 }, _renderList($props.errors, (error, index) => {
          return (_openBlock(), _createElementBlock("p", {
            id: $props.inputId + '-error',
            key: $props.inputId + '-error-' + index,
            class: "form__error"
          }, _toDisplayString(error), 9 /* TEXT, PROPS */, _hoisted_31))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}